import React, { useState, useMemo, useEffect, useContext, useCallback } from "react";
import { useSelector } from "react-redux";
import BreadCrumb from "../../../common/breadCrumb/BreadCrumb";
import Loader from "../../../common/Loader/Loader";
import { getYearOptions } from "../../../services/utilities";
import { getDashboard } from "../../../services/DashboardService";
import { ClaimsContext } from "../../../services/ClaimsService";
import debounce from "lodash/debounce";
import {
    MRT_ToggleFiltersButton,
    MRT_ToggleGlobalFilterButton,
    MaterialReactTable,
    useMaterialReactTable,
} from "material-react-table";
import moment from "moment";
import { Box, Tooltip, IconButton } from "@mui/material";
import { Button, ICONS, Icon, GenericDropdown, Label, Input, COLORS, Modal } from "abs-ui-components";
import { FeatureType } from "../../../constants/FeatureToggles";
import * as _ from "lodash";
import { useNavigate } from "react-router-dom";
import axiosHttp from "../../../services/interceptor";
import { accessAPIForResponse } from "../../../services/api-services/api-implementations";
import { emitToasterMsg } from "../../../services/toasterUtility";
import { HighlightedCell, MultiSelectFilter } from "../../../utils/filterUtils";
import { FEU_COMPLIANCE_BALANCE_REPORTS_COLUMNS } from "./FEUComplianceBalanceReportsColumns";
import { ClaimType } from "../../../constants/claims";
import { REPORT_SUBMISSION_DATA } from "../../../constants/ReportedDataMenus_constants";
import DeleteIcon from "@mui/icons-material/Delete";
import AbsModal from "../../../common/absModal/AbsModal";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { MDBCol, MDBRow } from "mdbreact";
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { WCNList } from "../../../services/AdminService";
import { PropTypes } from "prop-types";
import { CustomTableRow } from "../../../components/SignInModule/UserAutherization/utilities";
import { CANCEL, DELETE, DELETE_CONFIRMATION_TEXT_FOR_SINGLE_RECORD } from "../../../constants/CommonConstants";
import { ClearIcon } from "@mui/x-date-pickers";
import "./FEUComplianceBalanceReportsPage.scss";

const FEUComplianceBalanceReportsPage = () => {
    const baseURL = process.env.REACT_APP_BASE_URL;
    const { userHasClaim, userHasFeature, userFeaturesAreLoaded } = useContext(ClaimsContext);
    const user = useSelector((state) => state.userInfo.userData);
    const [pageLoader, setPageLoader] = useState(false);
    const [options, setOptions] = useState([]);
    const currentYear = moment().year();
    const [isCreateReportModalOpen, setIsCreateReportModalOpen] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 25,
    });
    const navigate = useNavigate();
    const [columnFilters, setColumnFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [pendingColumnFilters, setPendingColumnFilters] = useState([]);
    const [pendingGlobalFilter, setPendingGlobalFilter] = useState("");
    const [appliedGlobalFilter, setAppliedGlobalFilter] = useState("");
    const [engineersOptions, setEngineersOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedEngineer, setSelectedEngineer] = useState("");
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [selectedFeuReport, setSelectedFeuReport] = useState();
    const [disableAssignBtn, setdisableAssignBtn] = useState(true);
    const [actionBtnName, setActionBtnName] = useState("");
    const [showModel, setShowModel] = useState(false);
    const [selectedReport, setselectedReport] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [refreshTable, setRefreshTable] = React.useState(false);
    const getReportingYear =
        localStorage.getItem("selectedYear") || currentYear.toString();
    const [selectedYearOption, setSelectedYearOption] = useState([
        getReportingYear,
    ]);

    const reportStatuses = useMemo(
        () => [
            "Crosscheck In Progress",
            "Verification In Progress",
            "Verification Completed",
        ],
        []
    );

    const breadcrumb = useMemo(
        () => [
            {
                label: "Annual Emission Verification",
                url: "",
                navId: "annual_emission_verification_navid",
            },
            {
                label: "FEU Compliance Balance Reports",
                url: "",
                navId: "feu_compliance_balance_reports_navid",
            },
        ],
        []
    );

    const [showbreadCrumb, setShowBreadCrumb] = useState(() => {
        const storedValue = sessionStorage.getItem("header-footer");
        return storedValue !== null ? JSON.parse(storedValue) : true;
    });

    // Create a debounced setter function
    const debouncedSetHeaderFooterEnabled = debounce((value) => {
        setShowBreadCrumb(value);
    }, 100);

    const isLegacyReportsEnabled =
        userFeaturesAreLoaded && userHasFeature(FeatureType.LegacyReports);

    var feuCbvrEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.ShowFeuCbvr));

    useEffect(() => {
        const storedValue = sessionStorage.getItem("header-footer");
        if (storedValue !== null) {
            debouncedSetHeaderFooterEnabled(JSON.parse(storedValue));
        }
    }, [debouncedSetHeaderFooterEnabled]);

    useEffect(() => {
        const loadOptions = async () => {
            const yearOptions = getYearOptions(isLegacyReportsEnabled);
            if (yearOptions.length > 0) {
                setOptions(yearOptions);
            } else {
                const fetchedDashboardData = await getDashboard();
                const years = fetchedDashboardData?.DashboardReportYears;
                const yearOptions = _.map(years, (x) => {
                    return { label: x.ReportYear, value: x.ReportYear };
                });
                setOptions(yearOptions);
                localStorage.setItem(
                    "report-years",
                    JSON.stringify(yearOptions)
                );
            }
        };
        loadOptions();
    }, []);

    const onReportYearChange = (selected) => {
        setSelectedYearOption(selected);
        let selectedYearOption = selected[0] || getReportingYear;
        localStorage.setItem("selectedYear", selectedYearOption);
    };

    const getAllEngineers = async (input) => {
        try {
            const response = await accessAPIForResponse(
                "GetReviewEngineers",
                null,
                [input]
            );
            if (response) {
                const res = response.map((engineer) => engineer.emailAddress);

                setEngineersOptions(res);
            } else {
                setEngineersOptions([]);
            }
        } catch (error) {
            console.error("Error fetching engineers:", error);
            setEngineersOptions([]);
        }
    };

    const GetEngineersList = async (input) => {
        try {
            const response = await accessAPIForResponse(
                "GetReviewEngineers",
                null,
                [input]
            );
            if (response) {
                const engineers_options = response.map((obj, index) => ({
                    label: obj.emailAddress,
                    value: obj.emailAddress,
                    id: index + 1,
                }));
                return engineers_options;
            }
            return [];
        } catch (error) {
            console.error("Error fetching engineers:", error);
            return [];
        }
    };

    const getButtonType = (rowData) => {
        if (rowData.showClaimButton) return "Claim";
        else if (rowData.showReassignButton) return "Re-Assign";
        else if (rowData.showUnclaimButton) return "Un-Claim";
        else if (rowData.showAssignButton) return "Assign";
    };

    const getFeuCBRData = async () => {
        try {
            setLoading(true);
            const payload = {
                globalFilter: appliedGlobalFilter,
                filters: columnFilters.map((filter) => ({
                    key: filter.id,
                    value: Array.isArray(filter.value)
                        ? filter.value.map((item) => {
                            if (item === "@Me") {
                                return user?.email;
                            }

                            if (item === "@Unassigned") {
                                return "";
                            }

                            return item;
                        })
                        : filter.value,
                })),
                pagination: {
                    page: pagination.pageIndex + 1,
                    pageSize: pagination.pageSize,
                },
                sortOption: {
                    sortField: sorting?.[0]?.id ?? "",
                    isAscending: !sorting?.[0]?.desc,
                },
                reportYear: selectedYearOption[0],
            };
            const response = await axiosHttp.post(
                `${baseURL}api/FeuComplianceBalance/grid`,
                payload
            );

            setTableData(response?.data?.data.map((row) => ({
                ...row,
                actionBtnName: getButtonType(row)
            })) ?? []);

            setRowCount(
                response?.data?.pagination?.totalItems ?? 0
            );
        } catch (error) {
            console.error("Failed to fetch CER WCN data", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getFeuCBRData();
    }, [selectedYearOption, pagination, columnFilters, sorting, appliedGlobalFilter, refreshTable]);

    const applyFilters = () => {
        const cleanedFilters = pendingColumnFilters
            .map(filter => {
                if (Array.isArray(filter.value)) {
                    return {
                        ...filter,
                        value: filter.value.map(v =>
                            typeof v === 'string' ? v.trim() : v
                        ).filter(v => v !== "")
                    };
                }
                if (typeof filter.value === 'string') {
                    const trimmedValue = filter.value.trim();
                    return trimmedValue === "" ? null : { ...filter, value: trimmedValue };
                }
                return filter;
            })
            .filter(filter => filter !== null &&
                (!Array.isArray(filter.value) || filter.value.length > 0)
            );
        setColumnFilters(cleanedFilters);
        setAppliedGlobalFilter(pendingGlobalFilter?.trim() || "");

        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
        setPendingColumnFilters(cleanedFilters);
    };

    const clearFilters = () => {
        setPendingColumnFilters([]);
        setColumnFilters([]);
        setPendingGlobalFilter("");
        setAppliedGlobalFilter("");
        setPagination((prev) => ({
            ...prev,
            pageIndex: 0,
        }));
    };

    useEffect(() => {
        if (!pendingGlobalFilter && appliedGlobalFilter !== "") {
            setAppliedGlobalFilter("");
            setPagination((prev) => ({
                ...prev,
                pageIndex: 0,
            }));
        }
    }, [pendingGlobalFilter, appliedGlobalFilter]);

    const handleModel = (btnName, mstId) => {
        if (selectedEngineer === !"") {
            setdisableAssignBtn(false);
        } else {
            setdisableAssignBtn(true);
        }

        setActionBtnName(btnName);
        setselectedReport(mstId);
        if (btnName.includes("Assign")) {
            setShowModel(true);
        } else {
            assignEngineer(user ? user?.email : null, btnName, mstId);
        }
    };

    const getFilterValue = useCallback(
        (columnId) => {
            const filter = pendingColumnFilters.find(
                (f) => f.id === columnId
            );

            return filter?.value || [];
        },
        [pendingColumnFilters]
    );

    const updateFilterValue = useCallback(
        (columnId, value) => {

            const isCleared =
                (Array.isArray(value) && value.length === 0) ||
                value === "" ||
                value == null;

            // update pending filters
            setPendingColumnFilters((prev) => {

                const others = prev.filter(
                    (f) => f.id !== columnId
                );

                return !isCleared
                    ? [
                        ...others,
                        {
                            id: columnId,
                            value,
                        },
                    ]
                    : others;
            });

            // handle applied filters separately
            setColumnFilters((prevApplied) => {

                const appliedFilter = prevApplied.find(
                    (f) => f.id === columnId
                );

                const wasApplied =
                    appliedFilter &&
                    (
                        (Array.isArray(appliedFilter.value) &&
                            appliedFilter.value.length > 0) ||
                        (!Array.isArray(appliedFilter.value) &&
                            appliedFilter.value !== "" &&
                            appliedFilter.value != null)
                    );

                // only auto-clear if previously applied
                if (isCleared && wasApplied) {

                    setPagination((prev) => ({
                        ...prev,
                        pageIndex: 0,
                    }));

                    return prevApplied.filter(
                        (f) => f.id !== columnId
                    );
                }

                return prevApplied;
            });
        },
        []
    );

    useEffect(() => {
        getAllEngineers("");
    }, []);

    const handleDeleteConfirm = (row, isConfirm) => {
        setConfirmDelete(isConfirm);
        setSelectedFeuReport(row);
    };

    const handleDelete = async () => {
        setLoading(true);
        try {
            const responseData = await axiosHttp.delete(`${baseURL}api/FeuComplianceBalance/delete-report?reportId=${selectedFeuReport?.original?.reportId}`);
            if (responseData?.data?.isSuccess) {
                getFeuCBRData();
                setLoading(false);
                emitToasterMsg("success", "Delete", "Report Deleted Successfully");
            } else {
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
        setConfirmDelete(false);
    };

    const toggleClose = () => {
        setShowModel(false);
    };

    const handleSelect = (select) => {
        setSelectedEngineer(select?.value);
        setdisableAssignBtn(false);
    };

    const assignEngineer = async (engineer, btnName, mstId) => {
        await axiosHttp.post(
            btnName === "Claim"
                ? "api/FeuComplianceBalance/claim-report?reportId=" + mstId
                : btnName === "Un-Claim"
                    ? "api/FeuComplianceBalance/unclaim-report?reportId=" + selectedReport
                    : "api/FeuComplianceBalance/assign-reviewer?reportId=" + selectedReport + "&userEmail=" + engineer,
            // requestPayLoad,
            []
        )
            .then((response) => {
                if (response && response?.data?.isSuccess) {
                    setdisableAssignBtn(true);
                    setShowModel(false);
                    setAppliedGlobalFilter(
                        appliedGlobalFilter ? appliedGlobalFilter : ""
                    );
                    toggleRefreshTable();
                } else console.error(response?.data?.errorMessage);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const wcnLoadOptions = async (inputValue) => {
        try {
            const response = await WCNList(inputValue);
            const formattedWCNOptions = response?.map((item) => ({
                label: `${item.CompanyName}`,
                value: `${item.WcnNumber}`,
                wcnMappingId: item.WcnMstId,
            }));
            return formattedWCNOptions;
        } catch (error) {
            emitToasterMsg("error", "Error", error.message);
            return [];
        }
    };

    const methods = useForm({
        defaultValues: {
            wcn: null,
            companyImoNumber: "",
            companyName: "",
        },
    });

    const errors = methods.formState.errors;

    const formProperties = {
        wcn: "wcn",
        companyImoNumber: "companyImoNumber",
        companyName: "companyName",
    };

    const toggleRefreshTable = () => {
        setRefreshTable((prev) => !prev);
    };

    const handleFormSubmit = async (data) => {
        try {
            setIsSubmitting(true);
            const payload = {
                reportYear: selectedYearOption[0],
                wcnMstId: data?.wcn?.wcnMappingId,
                companyImoNumber: data?.companyImoNumber,
                companyName: data?.companyName,
            };

            const response = await axiosHttp.post(`${baseURL}api/FeuComplianceBalance/create-report`, payload);
            if (response?.status === 200) {
                emitToasterMsg("success", "Success", "Created successfully");
                toggleRefreshTable();
                methods.reset();
                setIsCreateReportModalOpen(false);
            }
            else {
                emitToasterMsg("error", "Error", response?.data?.errorMessage || "Something went wrong while creating compliance balance report");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.errorMessage || error?.message || "Something went wrong while creating compliance balance report";
            emitToasterMsg("error", "Error", errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleReportListTableRowClick = (row, column) => {
        column.id !== "actionBtnName" && column.id !== "download" && column.id !== "delete" &&
            navigate(`/feu-compliance-balance-reports/${row.original.reportId}`);
    };

    const reportListColumns = useMemo(() => {
        return [
            ...FEU_COMPLIANCE_BALANCE_REPORTS_COLUMNS,
            {
                accessorKey: "status",
                header: "Status",

                Cell: ({ cell }) => (
                    <HighlightedCell
                        value={cell.getValue()}
                        columnId="status"
                        reportListColumnFilters={
                            pendingColumnFilters
                        }
                        user={user}
                    />
                ),

                Filter: () => (
                    <MultiSelectFilter
                        columnId="status"
                        options={reportStatuses}
                        placeholder="Filter Status"
                        columnWidth='250px'
                        getFilterValue={getFilterValue}
                        updateFilterValue={updateFilterValue}
                    />
                ),
            },
            {
                accessorKey: "latestReviewer",
                header: "Latest Reviewer",

                Cell: ({ cell }) => (
                    <HighlightedCell
                        value={cell.getValue()}
                        columnId="latestReviewer"
                        reportListColumnFilters={
                            pendingColumnFilters
                        }
                        user={user}
                    />
                ),

                Filter: () => (
                    <MultiSelectFilter
                        columnId="latestReviewer"
                        options={[
                            ...(user?.roles?.some(
                                (role) =>
                                    role === "ER_REVIEWER" || role === "ER_SUPERADMIN"
                            ) ? ["@Me"] : []),
                            "@Unassigned",
                            ...engineersOptions
                        ]}
                        placeholder="Filter by Reviewer"
                        columnWidth='300px'
                        getFilterValue={getFilterValue}
                        updateFilterValue={updateFilterValue}
                    />
                ),
            },
            {
                accessorKey: "latestVerifier",
                header: "Latest Verifier",

                Cell: ({ cell }) => (
                    <HighlightedCell
                        value={cell.getValue()}
                        columnId="latestVerifier"
                        reportListColumnFilters={
                            pendingColumnFilters
                        }
                        user={user}
                    />
                ),

                Filter: () => (
                    <MultiSelectFilter
                        columnId="latestVerifier"
                        options={[
                            ...(user?.roles?.some(
                                (role) =>
                                    role === "ER_VERIFIER" || role === "ER_SUPERADMIN"
                            ) ? ["@Me"] : []),
                            "@Unassigned",
                            ...engineersOptions
                        ]}
                        placeholder="Filter by Verifier"
                        columnWidth='300px'
                        getFilterValue={getFilterValue}
                        updateFilterValue={updateFilterValue}
                    />
                ),
            },
        ];
    }, [reportStatuses, pendingColumnFilters, engineersOptions, user, columnFilters, appliedGlobalFilter]);

    const handleColumnFilterChange = (updater) => {
        setPendingColumnFilters((prev) => {

            const updated =
                typeof updater === "function"
                    ? updater(prev)
                    : updater;

            // detect removed filters
            const removedFilters = prev.filter(
                (oldFilter) =>
                    !updated.some(
                        (newFilter) =>
                            newFilter.id === oldFilter.id
                    )
            );

            // only consider filters that were actually applied
            const removedAppliedFilters =
                removedFilters.filter((removedFilter) =>
                    columnFilters.some(
                        (appliedFilter) =>
                            appliedFilter.id === removedFilter.id
                    )
                );

            // auto apply ONLY if applied filter removed
            if (removedAppliedFilters.length > 0) {

                setPagination((prev) => ({
                    ...prev,
                    pageIndex: 0,
                }));

                setColumnFilters((prevApplied) =>
                    prevApplied.filter(
                        (appliedFilter) =>
                            updated.some(
                                (updatedFilter) =>
                                    updatedFilter.id === appliedFilter.id
                            )
                    )
                );
            }

            return updated;
        });
    };

    const table = useMaterialReactTable({
        columns: [
            ...reportListColumns,
            {
                id: "download",
                header: "",
                size: 50,
                enableColumnActions: false,
                enableColumnFilter: false,
                enableSorting: false,


                Cell: ({ row }) => {
                    const handleDownloadClick = async () => {
                        setPageLoader(true);
                        await axiosHttp.get(`${baseURL}api/FeuComplianceBalance/download-report-docs?reportId=${row.original.reportId}`, {
                            responseType: "blob",
                        })
                            .then((response) => {
                                setPageLoader(false);
                                const url = window.URL.createObjectURL(
                                    new Blob([response.data], {
                                        type: response?.type,
                                    })
                                );
                                const link = document.createElement("a");
                                link.href = url;
                                link.setAttribute(
                                    "download",
                                    "Report documents.zip"
                                );
                                document.body.appendChild(link);
                                link.click();
                                emitToasterMsg(
                                    "success",
                                    "Report downloaded successfully."
                                );
                            })
                            .catch((error) => {
                                setPageLoader(false);
                                console.error(error);
                            });
                    };
                    return (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                            <Tooltip title="Download">
                                <Button
                                    outline={true}
                                    isIconOnly
                                    variant="tertiary"
                                    disabled={!row.original?.isDocsAvailable}
                                    onClick={(e) => {
                                        if (row.original?.isDocsAvailable) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            handleDownloadClick();
                                        }
                                    }}
                                >
                                    <Icon
                                        icon={ICONS.DOWNLOAD}
                                        disabled={!row.original?.isDocsAvailable}
                                        className="d-flex"
                                        outline={true}
                                        size="24px"
                                    />
                                </Button>
                            </Tooltip>
                        </Box>
                    )
                },
            },
            {
                accessorKey: "actionBtnName",
                accessorFn: (row) =>
                    row.actionBtnName ? (
                        <Box
                            sx={{
                                display: "flex",
                                gap: "1rem",
                                width: "120px",
                            }}
                        >
                            <Tooltip title="Manage">
                                <Button
                                    onClick={() => {
                                        setSelectedEngineer(row.latestReviewer);
                                        handleModel(
                                            row.actionBtnName,
                                            row.reportId
                                        );
                                    }}
                                >
                                    {row.actionBtnName}
                                </Button>
                            </Tooltip>
                        </Box>
                    ) : row.latestReviewer !== "" &&
                        userHasClaim(ClaimType.CLAIM_REPORT)
                        ? (
                            <p className="">
                                Claimed By <br />
                                {row.latestReviewer}
                            </p>
                        ) : (
                            ""
                        ),
                header: "",
                enableColumnActions: false,
                enableColumnFilter: false,
            },
            {
                id: "delete",
                header: "",
                accessorKey: "delete",
                enableEditing: false,
                enableColumnActions: false,
                enableColumnFilter: false,
                size: 100,
                Cell: ({ row }) => {
                    const reportStatus = row.original.status;
                    const showDeleteBtn =
                        user?.roles?.includes("ER_SUPERADMIN") ? true :
                            (user?.roles?.includes("ER_VERIFIER") || user?.roles?.includes("ER_REVIEWER")) ?
                                (reportStatus?.toLowerCase() === REPORT_SUBMISSION_DATA.SUBMITTED_ABS_REPORT_STATUS?.toLowerCase() || reportStatus?.toLowerCase() === REPORT_SUBMISSION_DATA.VERIFICATION_PROGRESS_REPORT_STATUS?.toLowerCase()) :
                                false;

                    if (showDeleteBtn) {
                        return (
                            <Box sx={{ display: "flex", gap: "1rem" }}>
                                <Tooltip title="Delete">
                                    <IconButton color="error" onClick={() => handleDeleteConfirm(row, true)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        );
                    }
                },
            }
        ],
        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                cursor: "pointer !important",
                '&:hover': {
                    backgroundColor: 'action.hover',
                },
            },
        }),
        muiTableBodyCellProps: ({ row, row: { original }, column }) => ({
            sx: {
                cursor: "pointer",
            },
            component: CustomTableRow,
            ReportMstId: original.reportId,
            column: column,
            onClick: () => handleReportListTableRowClick(row, column),
        }),
        data: tableData,
        enableStickyHeader: true,
        manualPagination: true,
        manualFiltering: true,
        manualSorting: true,
        enableFullScreenToggle: false,
        toggledensity: false,
        rowCount,
        enableExpandAll: false,
        enableExpanding: false,
        enableSorting: false,
        enableTopToolbar: true,
        enableHiding: false,

        state: {
            pagination,
            columnFilters: pendingColumnFilters,
            globalFilter: pendingGlobalFilter,
            sorting,
            isLoading: loading,
        },
        onPaginationChange: setPagination,
        onColumnFiltersChange: handleColumnFilterChange,
        // onGlobalFilterChange: setPendingGlobalFilter,
        onSortingChange: setSorting,
        initialState: {
            density: "compact",
            columnOrder: [
                "download",
                "wcnNumber",
                "wcnCompanyName",
                "companyName",
                "companyImoNumber",
                "feuCbvrId",
                "modifiedDate",
                "status",
                "actionBtnName",
                "latestReviewer",
                "latestVerifier",
                "delete"
            ],
        },
        muiPaginationProps: {
            rowsPerPageOptions: [25, 50, 75, 100],
            showFirstButton: true,
            showLastButton: true,
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: "calc(100vh - 379px)",
            },
        },
        renderToolbarInternalActions: ({ table }) => (
            <>
                <MRT_ToggleGlobalFilterButton
                    id="reports_view_global_search"
                    table={table}
                />
                <MRT_ToggleFiltersButton
                    id="reports_view_global_filter"
                    table={table}
                />
                <Button
                    className="ml-2"
                    onClick={applyFilters}
                >
                    Apply Filters
                </Button>
                <Button
                    className="ml-2"
                    variant="secondary"
                    onClick={clearFilters}
                >
                    Clear
                </Button>
            </>
        ),
        muiFilterTextFieldProps: ({ column }) => ({
            sx: {
                "& .MuiInput-root": {
                    color: "white !important",
                },
                "& .MuiButtonBase-root": {
                    color: "white !important",
                },
                "& .MuiInputBase-root::after": {
                    transform: "none",
                    borderBottom: "1px solid white",
                },
            },
            onKeyDown: (e) => {
                if (e.key === "Enter") {
                    applyFilters();
                }
            },
        }),
        muiSearchTextFieldProps: {
            placeholder: "Type and Enter",
            value: pendingGlobalFilter,

            onChange: (e) => {

                const value = e.target.value;

                setPendingGlobalFilter(value);

                // auto reset when cleared
                if (!value.trim()) {

                    setPagination((prev) => ({
                        ...prev,
                        pageIndex: 0,
                    }));

                    setAppliedGlobalFilter("");
                }
            },

            onKeyDown: (e) => {
                if (e.key === "Enter") {
                    applyFilters();
                }
            },
            InputProps: {
                endAdornment: pendingGlobalFilter && (
                    <IconButton
                        size="small"
                        onClick={() => {
                            setPendingGlobalFilter("");
                            setAppliedGlobalFilter("");
                            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
                        }}
                        sx={{ visibility: pendingGlobalFilter ? "visible" : "hidden" }}
                    >
                        <ClearIcon fontSize="small" />
                    </IconButton>
                ),
            },
        }
    });

    const handleCreateModel = () => {
        methods.reset();
        setIsCreateReportModalOpen(!isCreateReportModalOpen);
    }

    const handleOk = () => {
        navigate("/dashboard");
    };

    return (
        <section className="feu-compliance-balance-reports-page p-4">
            {pageLoader && <Loader />}
            {showbreadCrumb && <BreadCrumb items={breadcrumb} />}
            {feuCbvrEnabled ? (
                <>
                    <div className="d-flex flex-row justify-content-between px-3">
                        <div className="reporting-yr-wrapper d-flex">
                            <Label className="mr-3" name="Reporting Year" bold />
                            <div className="drop-down-container">
                                <GenericDropdown
                                    options={options}
                                    selected={selectedYearOption}
                                    handleChange={onReportYearChange}
                                    placeholder={selectedYearOption[0]}
                                />
                            </div>
                        </div>

                        <div className="d-flex flex-row justify-content-between">

                            {showbreadCrumb && (user?.roles?.includes("ER_VERIFIER") || user?.roles?.includes("ER_SUPERADMIN") || user?.roles?.includes("ER_REVIEWER")) && (
                                <Button
                                    className="justify-content-end mr-2"
                                    startIcon={<Icon icon={"add"} />}
                                    disabled={isCreateReportModalOpen}
                                    onClick={handleCreateModel}
                                >
                                    Create CB Verification Report
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className="mt-4 report-list-table">
                        <MaterialReactTable table={table} />
                        <Modal
                            isOpen={confirmDelete}
                            modalHeader
                            padding={"70px"}
                            headerHeight={"50px"}
                            showFooter
                            onCloseClickListener={() => {
                                setConfirmDelete(false);
                            }}
                            footer={
                                <div className="d-flex justify-content-end fixed-action-btns p-4">
                                    <Button
                                        className="modal-delete-btn"
                                        onClick={() => handleDelete()}
                                        primaryColor={COLORS.RED.DARK}
                                        primaryBackgroundColor={COLORS.RED.LIGHT}
                                    >
                                        {DELETE}
                                    </Button>
                                    <Button
                                        className="modal-cancel-btn ml-2"
                                        onClick={() => {
                                            setConfirmDelete(false);
                                        }}
                                    >
                                        {CANCEL}
                                    </Button>
                                </div>
                            }
                        >
                            <div>{DELETE_CONFIRMATION_TEXT_FOR_SINGLE_RECORD}</div>
                        </Modal>
                    </div>
                    {isCreateReportModalOpen && (
                        <AbsModal
                            isOpen={isCreateReportModalOpen}
                            title="Create CB Verification Report"
                            onClose={setIsCreateReportModalOpen}
                            close={handleCreateModel}
                        >
                            <div>
                                <FormProvider {...methods}>
                                    <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
                                        <div className="form-container">
                                            <MDBRow className="justify-content-center">
                                                <MDBCol md="12">
                                                    <MDBRow className="d-flex my-4 wcn">
                                                        <MDBCol md="12" className="wcn-dropdown">
                                                            <Controller
                                                                name={formProperties.wcn}
                                                                rules={{
                                                                    required: "WCN is required",
                                                                }}
                                                                control={methods.control}
                                                                render={({ field }) => {
                                                                    return (
                                                                        <>
                                                                            <AutocompleteDropdown
                                                                                className="inputHeight w-100"
                                                                                id="management_company_wcn"
                                                                                isClearable
                                                                                value={field.value ?? null}
                                                                                onChange={field.onChange}
                                                                                loadOptions={wcnLoadOptions}
                                                                                getOptionLabel={(option) => `${option.value} - ${option.label}`}
                                                                                placeholder={"Please Select WCN"}
                                                                                customStyles={{
                                                                                    menuList: (provided) => ({
                                                                                        ...provided,
                                                                                        maxHeight: 160,
                                                                                    }),
                                                                                }}
                                                                            />
                                                                            {errors["wcn"] && (
                                                                                <p className="error">
                                                                                    {
                                                                                        errors["wcn"]
                                                                                            .message
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    );
                                                                }}
                                                            ></Controller>
                                                        </MDBCol>
                                                    </MDBRow>
                                                    <MDBRow className="d-flex my-4 wcn">
                                                        <MDBCol md="4" className="company-imo-dropdown">
                                                            <div>
                                                                <Label name="Company IMO Number" bold required />
                                                                <Controller
                                                                    name="companyImoNumber"
                                                                    control={methods.control}
                                                                    rules={{
                                                                        required: "Company IMO Number is required",
                                                                        pattern: {
                                                                            value: /^\d{7}$/,
                                                                            message:
                                                                                "Company IMO Number must be exactly 7 characters",
                                                                        },
                                                                    }}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <Input
                                                                                id="Company Imo Number"
                                                                                type="text"
                                                                                onChange={field.onChange}
                                                                                value={field.value || ""}
                                                                                autoFocus={false}
                                                                                className="input-content mt-2"
                                                                                // placeholder="Please add Company IMO Number"
                                                                                maxLength={7}

                                                                            />
                                                                            {errors["companyImoNumber"] && (
                                                                                <p className="error">
                                                                                    {
                                                                                        errors["companyImoNumber"]
                                                                                            .message
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                />
                                                            </div>
                                                        </MDBCol>

                                                        <MDBCol md="8">
                                                            <div>
                                                                <Label name="Company Name" bold required />
                                                                <Controller
                                                                    name="companyName"
                                                                    control={methods.control}
                                                                    rules={{
                                                                        required: "Company Name is required",
                                                                    }}
                                                                    render={({ field }) => (
                                                                        <>
                                                                            <Input
                                                                                id="companyName"
                                                                                type="text"
                                                                                onChange={field.onChange}
                                                                                value={field.value || ""}
                                                                                autoFocus={false}
                                                                                className="input-content mt-2"
                                                                            // placeholder="Please add Company Name"
                                                                            />
                                                                            {errors["companyName"] && (
                                                                                <p className="error">
                                                                                    {
                                                                                        errors["companyName"]
                                                                                            .message
                                                                                    }
                                                                                </p>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                />
                                                            </div>
                                                        </MDBCol>
                                                    </MDBRow>
                                                </MDBCol>
                                            </MDBRow>
                                            <div className="d-flex justify-content-end fixed-action-btns pt-3 ml-2">
                                                <button
                                                    type="submit"
                                                    className="Create text-center"
                                                >
                                                    Create
                                                </button>
                                                <button
                                                    onClick={handleCreateModel}
                                                    className="cancel-btn ml-2"
                                                    type="button"
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </FormProvider>
                            </div>
                        </AbsModal>
                    )}
                    {showModel && (
                        <div className="assign-modal">
                            <AbsModal
                                isOpen={showModel}
                                title={"Assignment"}
                                onClose={setShowModel}
                                close={toggleClose}
                            >
                                <div className="ml-3">
                                    <h4 className="blod">Assignment</h4>
                                    <hr />
                                    <p>Please select an Engineer</p>
                                    <hr />

                                    <AutocompleteDropdown
                                        className="inputHeight"
                                        id="search-vessel-id"
                                        isClearable
                                        loadOptions={async (inputText) => {
                                            const options = await GetEngineersList(
                                                inputText
                                            );
                                            return options;
                                        }}
                                        placeholder={
                                            selectedEngineer || "Select an Engineer"
                                        }
                                        autoFocus={false}
                                        onChange={handleSelect}
                                        customStyles={{
                                            menuList: (provided) => ({
                                                ...provided,
                                            }),
                                        }}
                                    />

                                    <div className="d-flex justify-content-end mr-3 assignment-model-btns">
                                        <Button
                                            className="mr-3"
                                            id="assign-claim-btn-report-list"
                                            onClick={() => {
                                                assignEngineer(
                                                    selectedEngineer,
                                                    actionBtnName
                                                );
                                            }}
                                            disabled={disableAssignBtn}
                                        >
                                            Assign/Reassign
                                        </Button>
                                        <Button
                                            id="cancel-btn-report-list"
                                            variant="secondary"
                                            onClick={() => {
                                                toggleClose();
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            </AbsModal>
                        </div>
                    )}
                </>
            )
                : (
                    <div>
                        <Modal
                            isOpen={!feuCbvrEnabled}
                            modalHeader
                            padding={"70px"}
                            headerHeight={"50px"}
                            showFooter
                            footer={
                                <div className="d-flex justify-content-end fixed-action-btns p-4">
                                    <Button
                                        className="modal-delete-btn"
                                        onClick={handleOk}
                                        primaryColor={COLORS.RED.DARK}
                                        primaryBackgroundColor={COLORS.RED.LIGHT}
                                    >
                                        Ok
                                    </Button>
                                </div>
                            }
                        >
                            <div>You are not authorized to view this.</div>
                        </Modal>
                    </div>
                )}
        </section>
    );
}

const ErrorMsg = ({ errors, name }) => {
    return errors[name] ? <div className="error-msg">{errors[name].message}</div> : null;
};

ErrorMsg.propTypes = {
    name: PropTypes.string.isRequired,
    errors: PropTypes.object.isRequired,
};

export default FEUComplianceBalanceReportsPage;